import { InjectionToken } from '@angular/core';
import { NK_PARSER, NK_PARSER_DICTIONARY } from '@nitro/core/common';
import * as _moment from 'moment';
// eslint-disable-next-line no-duplicate-imports
import { DurationInputArg1, DurationInputArg2, Moment, unitOfTime } from 'moment';

import { NK_DEFAULT_DATE_TIME_PARSERS } from './date-time.parsers';
import { DateTimeRange } from '../types';

const moment = _moment;
// Keep next line to import NK_PARSER from @nitro/core and to prevent relative import from deploy
const _nkparser: NK_PARSER<Moment> = null;

export const NK_RANGE_DATE_TIME_PARSERS = new InjectionToken<NK_PARSER_DICTIONARY<DateTimeRange<Moment>>>(
  'NK_RANGE_DATE_TIME_PARSERS'
);

export const NK_DEFAULT_RANGE_DATE_TIME_PARSERS: NK_PARSER_DICTIONARY<DateTimeRange<Moment>> = new Map([
  [
    'today',
    (val: string, locale?: string) => {
      const todayString = { en: 'today', ro: 'astazi' };
      if (val.trim() === (todayString[locale || ''] || 'today')) {
        const m = moment();
        return { start: m.clone().startOf('day'), end: m.clone().endOf('day') };
      } else {
        return null;
      }
    }
  ],
  [
    'yesterday',
    (val: string, locale?: string) => {
      const todayString = { en: 'yesterday', ro: 'ieri' };
      if (val.trim() === (todayString[locale || ''] || 'yesterday')) {
        const m = moment();
        return {
          start: m.clone().subtract(1, 'day').startOf('day'),
          end: m.clone().subtract(1, 'day').endOf('day')
        };
      } else {
        return null;
      }
    }
  ],
  [
    'last',
    (val: string, locale?: string) => {
      const rx = /^last\s?([0-9]*)\s?(\w+)$/.exec(val.trim());
      if (rx && rx.length === 3) {
        const m = moment();
        const end = m.clone();
        const start = m.clone().subtract(Number(rx[1] || 1) as DurationInputArg1, rx[2] as DurationInputArg2);
        return start.valueOf() !== end.valueOf() ? { start: start, end: end } : null;
      } else {
        return null;
      }
    }
  ],
  [
    'this',
    (val: string, locale?: string) => {
      const rx = /^this\s?(\w+)$/.exec(val.trim());
      if (rx) {
        const m = moment();
        const end = m.clone().endOf(rx[1] as unitOfTime.StartOf);
        const start = m.clone().startOf(rx[1] as unitOfTime.StartOf);
        return start.valueOf() !== end.valueOf() ? { start: start, end: end } : null;
      } else {
        return null;
      }
    }
  ],
  [
    'individual_expressions',
    (val: string, locale?: string) => {
      const dtParser = NK_DEFAULT_DATE_TIME_PARSERS;
      const parsedf = (value, loc) => {
        if (value && typeof value === 'string' && dtParser) {
          for (const xp of Array.from(dtParser.values())) {
            const mxp = xp(value.trim(), loc);
            if (mxp && mxp.isValid()) {
              return mxp;
            }
          }
        }
      };

      if (val.indexOf('>') > -1) {
        const dates = val.split('>').map((v) => v.trim());
        return {
          start: parsedf(dates[0], locale),
          end: parsedf(dates[1], locale)
        };
      } else {
        return null;
      }
    }
  ]
]);
